
export default  {
  computed: {
    isDeviceConnectedToSB() {
      return !!this.smartBridgeDeviceId
    },
    isDeviceConnected() {
      return this.$store.getters['devices/getIsConnectedByDeviceId'](
        this.deviceId
      )
    },
    lastTelemetryTimestamp() {
      return this.$store.getters['devices/getLastContactByDeviceId'](
        this.deviceId
      )
    },
    isTelemetry24HrsActive(){
      return this.$store.getters['devices/getIsTelemetry24HrsActiveByDeviceId'](
        this.deviceId
      )
    },
    smartBridgeDeviceId() {
      return this.$store.getters['devices/getConnectedSmartBridgeIdByDeviceId'](
        this.deviceId
      )
    },
    isSmartBridgeConnected() {
      return this.$store.getters['devices/getIsConnectedByDeviceId'](
        this.smartBridgeDeviceId
      )
    },
    isWaitingInitialData() {
      const isTelemetryActive = !!this.lastTelemetryTimestamp && this.isTelemetry24HrsActive
      const isConnected = this.isDeviceConnectedToSB ? this.isDeviceConnected && this.isSmartBridgeConnected : this.isDeviceConnected
      return isConnected && !isTelemetryActive
    },
  },
}
